export const company_details = {
  name: 'Vortex Entertainment Private Limited',
  address:"101, Corporate Arena,Priamal Cross Road, Goregaon west,Mumbai-400104"
};
